import * as React from 'react';
export const UnifiedPressSystemEnableContext = React.createContext(false);
export function useIsUnifiedPressSystemEnabledEvents() {
    return React.useContext(UnifiedPressSystemEnableContext);
}

//# sourceMappingURL=UnifiedPressSystemEnableContext.js.map